import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { media } from 'consumer-components';
import { utils } from 'ui-common';

import Emblem from 'login-components/Emblem/Emblem';
import SignOutButton from 'login-components/Common/SignOutButton/SignOutButton';
import * as userUtils from 'login-utils/userUtils';
import * as featureFlags from 'login-utils/featureFlags';
import BackToPreviousApplicationButton from 'login-components/Common/BackToPreviousApplicationButton/BackToPreviousApplicationButton';

const styles = StyleSheet.create({
  mastheadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
  },
  masthead: {
    marginTop: '3%',
    marginBottom: '2.5%',
    [media.mobileMedium]: {
      justifyContent: 'left',
    },
  },
  topButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  signOutButton: {
    right: 20,
  },
  backButton: {
    left: 20,
  },
});

export default class Masthead extends React.PureComponent {
  render() {
    const displaySignoutButton =
      !!userUtils.getCurrentUser() && featureFlags.isEnabled('signoutButtonOnMoreLoginPages20190912');
    const displayBackButton =
      !!utils.cookieUtils.get('previousSelectedProductId') &&
      featureFlags.isEnabled('signoutButtonOnMoreLoginPages20190912');
    return (
      <div className={css(styles.mastheadWrapper)}>
        {displayBackButton && (
          <div className={css(styles.topButton, styles.backButton)}>
            <BackToPreviousApplicationButton />
          </div>
        )}
        <div className={css(styles.masthead)}>
          <Emblem />
        </div>
        {displaySignoutButton && (
          <div className={css(styles.topButton, styles.signOutButton)}>
            <SignOutButton buttonText="Sign Out" />
          </div>
        )}
      </div>
    );
  }
}
